import { useCallback, useEffect, useState } from "react";
import { Field } from "react-final-form";
import { CampoForm } from "./CampoForm";
import { required } from "../util/Required";
import ReactSelect from "react-select";
import { useAPIService } from "../../../hooks/useAPIService";

export function CampoSelectPesquisa(props) {
  const { get } = useAPIService()
  const [dados, setDados] = useState([]);
  const [carregando, setCarregando] = useState(false);
  let iconesDir = [];

  // Carrega ícones recebidos
  if (props.iconesDir) {
    iconesDir = props.iconesDir;
  }

  const carregarOpcoesServico = useCallback(
    async (dados) => {
      setTimeout(async () => {
        const servico = dados.split('|');

        setCarregando(true);
        setDados([]);

        const res = await get(servico[0], true, JSON.parse(servico[1]));
        setDados(res);

        setCarregando(false);
      }, 200);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Adiciona ícone de refresh para serviço
  if (props.servico) {
    let icone = {
      icone: 'sync-alt text-primary' + (carregando ? ' fa-spin' : ''),
      onClick: () => carregarOpcoesServico(props.servico),
      titleIcone: "Recarregar"
    };
    iconesDir = [...iconesDir, icone];
  }

  useEffect(() => {
    if ((!props.dados) && (props.servico)) {
      carregarOpcoesServico(props.servico);
    }
  }, [props.servico, props.dados, carregarOpcoesServico]);

  useEffect(() => {
    if(props.dados !== undefined){
      setDados(props.dados);
    }
  }, [props.dados]);

  useEffect(() => {
    if(props.carregando !== undefined){
      setCarregando(props.carregando);
    }
  }, [props.carregando]);

  let options = []

  if(props.todos){
    options.push({ label: 'Todos' })
  }

  if(props.selecione){
    options.push({ label: 'Selecione...' })
  }

  options = [
    ...options,
    ...dados.map(dado => ({
      value: (dado.codigo ?? dado.valor), // ajuste conforme a estrutura dos dados
      label: (dado.campo_select_texto ?? dado.texto) // ajuste conforme a estrutura dos dados
    }))
  ];
  
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%'
    }),
    control: (provided) => ({
      ...provided,
      width: '100%',
      padding: '.25rem .5rem',
      minHeight: 'calc(1.8125rem + 2px)',
      height: 'calc(1.8125rem + 2px)',
      alignContent: 'center',
      borderRadius: '.25rem',
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#86b7fe',
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 0'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#495057',
      padding: '8px 0px'
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      width: '0'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '.25rem',
      zIndex: 9999,
      marginTop: '2px'
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null, 
      color: state.isSelected ? 'white' : 'black',
      padding: '.25rem .75rem'
    })
  };

  const customStylesInvalid = {
    ...customStyles, 
    control: (provided) => ({
      ...provided,
      width: '100%',
      padding: '.25rem .5rem',
      minHeight: 'calc(1.8125rem + 2px)',
      height: 'calc(1.8125rem + 2px)',
      alignContent: 'center',
      borderRadius: '.25rem',
      borderColor: '#dc3545',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#dc3545'
      }
    }),
  }


  return (
    <Field name={props.nome} validate={((props.obrigatorio) ? required : undefined)}>
      {({ input, meta }) => {
        return (
          <CampoForm {...props} meta={meta} iconesDir={iconesDir} classe="react-select-custom">
            <ReactSelect
              options={options}
              value={options.find(option => (option.value + '') === (input.value + ''))}
              onChange={option => {
                input.onChange(option.value);
                if (props.onChange) {
                  props.onChange(option.value, props.index);
                }
              }}
              placeholder={props.placeholder ?? props.label}
              classNamePrefix="react-select"
              noOptionsMessage={(e) => "Nenhum registro encontrado"}
              styles={(((meta.error) && (meta.touched)) ? customStylesInvalid : customStyles)}
              isDisabled={props.readOnly ?? false}
            />
            {props.children}
          </CampoForm>
        );
      }}
    </Field>
  );
}